export default __webpack_public_path__ + "static/media/porto_faz.20e74315.png";